import { render, staticRenderFns } from "./Contratar2.vue?vue&type=template&id=21ae1d36&scoped=true&"
import script from "./Contratar2.vue?vue&type=script&lang=js&"
export * from "./Contratar2.vue?vue&type=script&lang=js&"
import style0 from "./Contratar2.vue?vue&type=style&index=0&id=21ae1d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae1d36",
  null
  
)

export default component.exports